import React from "react";
import { Route, IndexRoute } from "react-router";

import CreditContainer from "../components/common/credit/CreditContainer";
import Index from "../components/common/credit/Index"; // shows current credit and has a modal for recharge
// import PaymentSuccess from "../components/common/credit/PaymentSuccess";

export const creditRoutes = (
  <Route path="credit" component={CreditContainer}>
    <IndexRoute component={Index} />
    {/* depricated */}
    {/* <Route path="payment/success/pasargad/:paymentType" component={PaymentSuccess} /> */}
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes/creditAndPaymentRoutes.js